import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconIntegrationMango = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 18,
	viewBox: "0 0 27 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Group 1901",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group 1902",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M22.4291 5.6513C22.1022 5.6513 21.7745 5.60748 21.456 5.52068L19.72 5.04878L20.1877 3.29432C20.6255 1.64857 22.1072 0.5 23.7907 0.5C24.1176 0.5 24.4453 0.543819 24.7638 0.630615L26.4998 1.10336L26.0321 2.85782C25.5935 4.50273 24.1117 5.6513 22.4282 5.6513H22.4291Z",
				fill: "url(#paint0_linear_16956_72604)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M22.4285 6.61427C22.0175 6.61427 21.6064 6.55949 21.2078 6.45079L19.4718 5.97889L18.5504 5.72861L18.7989 4.79829L19.2667 3.04468C19.3175 2.85423 19.3826 2.67137 19.4551 2.49188C18.8322 2.27278 18.151 2.15649 17.4022 2.15649C15.4094 2.15649 13.961 2.82727 13.0255 4.16965C12.1499 2.82727 10.8217 2.15649 9.07228 2.15649C7.20034 2.15649 5.84203 2.76659 5.02738 3.98679V2.58373H0.499695V17.8354H5.02655V9.23331C5.02655 7.43419 5.90207 6.36568 7.38128 6.36568C8.86049 6.36568 9.55424 7.31201 9.55424 8.86675V17.8345H14.0811V9.23247C14.0811 7.43335 14.9566 6.36483 16.4358 6.36483C17.915 6.36483 18.6088 7.31116 18.6088 8.8659V17.8337H23.1356V8.469C23.1356 7.7898 23.0681 7.16369 22.9389 6.58309C22.7704 6.60163 22.6003 6.61511 22.4285 6.61511V6.61427Z",
				fill: "url(#paint1_linear_16956_72604)"
			})]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_16956_72604",
		x1: 20.3596,
		y1: 1.30937,
		x2: 23.5063,
		y2: 6.9098,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#61057F" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .518544,
				stopColor: "#0A0AE9"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0BF9F2"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint1_linear_16956_72604",
		x1: 2.63515,
		y1: 4.61997,
		x2: 11.7352,
		y2: 22.3859,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#61057F" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .518544,
				stopColor: "#0A0AE9"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0BF9F2"
			})
		]
	})] })]
});
export default SvgIconIntegrationMango;
